module.exports = __webpack_public_path__ + "static/media/money.a7ad4940.png";